<script setup lang="ts">
import { onUnmounted } from 'vue';
import { RouterView } from 'vue-router';

import { useAffiliateTrackersStore } from '../../submodules/trackers-list/store';

const { updateTrackersTableState } = useAffiliateTrackersStore();

onUnmounted(() => {
  updateTrackersTableState({ page: 1 });
});
</script>

<template>
  <RouterView />
</template>
